const _initialState = {
    isSettingsOpen: false,
    isHistoryOpen: true,
    favoritesModalOpen: false,
    addFavoritesModalOpen: false,
    singleView: true,
    multiView: false,
    favoriteAccounts: true,
    favoriteProductGroups: false
};

export default function domReducer(state = _initialState, action) {
    switch (action.type) {
    case "OPEN_SETTINGS":
        return {...state, isSettingsOpen: true};

    case "CLOSE_SETTINGS":
        return {...state, isSettingsOpen: false};

    case "OPEN_HISTORY":
        return {...state, isHistoryOpen: true};

    case "CLOSE_HISTORY":
        return {...state, isHistoryOpen: false};

    case "SET_FAVORITES_ACCOUNTS":
        return {
            ...state,
            favoriteAccounts: true,
            favoriteProductGroups: false
        };

    case "SET_FAVORITES_PRODUCT_GROUPS":
        return {
            ...state,
            favoriteAccounts: false,
            favoriteProductGroups: true
        };

    case "SINGLE_INPUT":
        return {
            ...state,
            singleView: true,
            multiView: false
        };

    case "MULTI_INPUT":
        return {
            ...state,
            singleView: false,
            multiView: true
        };

    default:
        return state;
    }
}



// WEBPACK FOOTER //
// ./app/reducers/domReducer.js